<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="claimStageTypes"
    item-value="name"
    item-text="description"
    clearable
    return-object
  >
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ClaimStageTypeField",
  props: {
    value: Object
  },
  data: () => ({
    claimStageTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    ApiService.get("/api/types/claimStages").then(({ data }) => {
      this.claimStageTypes = data;
    });
  }
};
</script>
